<script setup lang="ts">
import { Plus } from 'lucide-vue-next'
defineEmits<{ add: [] }>()
</script>

<template>
  <button type="button" class="addcard" @click="$emit('add')">
    <span class="addcard__icon"><Plus :size="18" /></span>
    <span class="addcard__label">New class</span>
  </button>
</template>

<style scoped>
.addcard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 168px;
  width: 100%;
  border: 1.5px dashed var(--outline);
  border-radius: var(--radius-lg);
  background: transparent;
  color: var(--ink-500);
  cursor: pointer;
  font-family: var(--font-sans);
  transition: background var(--motion-fast), border-color var(--motion-fast), color var(--motion-fast);
}
.addcard:hover {
  background: var(--palette-indigo-soft);
  border-color: var(--primary);
  color: var(--primary);
}
.addcard__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  background: var(--surface-variant);
  color: inherit;
}
.addcard:hover .addcard__icon {
  background: var(--surface);
}
.addcard__label {
  font-size: 14px;
  font-weight: 600;
}
</style>
